/*
src/ui-panels/ForegroundObjectsPanel.js
wgbh-skydiagram-testing
astro.unl.edu
2019-06-16
*/


import * as React from 'react';

import {ForegroundObjectsList} from '../ui-misc/ForegroundObjectsList.js';
import {ForegroundObjectDetail} from '../ui-misc/ForegroundObjectDetail.js';


export class ForegroundObjectsPanel extends React.Component {


	constructor(props) {
		super(props);

		this.forceRender = this.forceRender.bind(this);
		this.paramsManagerChangeCallback = this.paramsManagerChangeCallback.bind(this);
		this.handleSelectObject = this.handleSelectObject.bind(this);

		this._paramsMan = this.props.workspace.getParamsManager();
		this._paramsMan.registerCallback('change', this.paramsManagerChangeCallback);

		this.state = {
			dirtyCount: 1,
			selectedObject: null,
		};
	}


	forceRender() {
		this.setState(state => ({dirtyCount: state.dirtyCount+1}));
	}

	paramsManagerChangeCallback(type, caller, data) {

		// Verify that the selected object still exists if the foreground object array
		//	has changed. If not, clear the selection.
		if (data.newValues.hasOwnProperty('foregroundObjects')) {

			let stillExists = false;

			for (const fobj of data.newValues.foregroundObjects) {
				if (this.state.selectedObject === fobj) {
					stillExists = true;
					break;
				}
			}

			if (!stillExists) {
				this.setState({selectedObject: null});
			}
		}
	}

	handleSelectObject(foregroundObject) {
		this.setState(state => ({selectedObject: foregroundObject}));
	}


	render() {

		// The ForegroundObjectsList (shown at left) provides the selection list.
		// The ForegroundObjectDetail (shown at right) provides the controls for individual objects.
	
		return (
			<div style={{maxWidth: "850px", margin: "30px auto"}}>

				<ForegroundObjectsList selected={this.state.selectedObject} onSelect={this.handleSelectObject}
					workspace={this.props.workspace}
				/>

				<ForegroundObjectDetail selected={this.state.selectedObject} workspace={this.props.workspace} />
	
			</div>
		);
	}

}


